import React from "react";

import Highlighter from "react-highlight-words";

import { milliToDate } from "./../../../utils/commonUtil";

export const tabNameHandler = activeKey => {
  let apiType = "1";
  let tabType = "AllTransactions";
  let analytics = "All Transactions";

  switch (activeKey) {
    case "2":
      apiType = "contributions";
      tabType = "Contributions";
      analytics = "Contributions";
      break;

    case "3":
      apiType = "grants";
      tabType = "Grants";
      analytics = "Grants";
      break;

    case "4":
      apiType = "exchanges";
      tabType = "Exchanges";
      analytics = "Exchanges";
      break;

    case "5":
      apiType = "otherTransactions";
      tabType = "OtherTransactions";
      analytics = "Other transactions";
      break;

    default:
      apiType = "all";
      tabType = "AllTransactions";
      analytics = "All transactions";
      break;
  }
  return {
    apiType,
    tabType,
    analytics
  };
};

export const getTitleYearsText = data => {
  let yearsText = "";

  if (data.indexOf("Custom Dates") === -1 && data.length > 0) {
    data.forEach((year, i) => {
      if (i === data.length - 1 && data.length !== 1) {
        yearsText += " and " + year;
      } else if (data.length === 1) {
        yearsText += year;
      } else if (i === data.length - 2) {
        yearsText += year;
      } else {
        yearsText += year + ", ";
      }
    });
  }

  return yearsText;
};

export const getParenthesis = (data, type) => {
  // As for bugzilla -6215 we need to show parenthesis with some special scenario

  let isParenthesis = false;

  if (data.tabType === "Grant" || type === "Grants") {
    if (data.reversal) {
      isParenthesis = false;
    } else {
      isParenthesis = true;
    }
  } else if (
    data.tabType === "Other Transaction" ||
    type === "OtherTransactions"
  ) {
    if (data.decrease) {
      isParenthesis = true;
    } else {
      isParenthesis = false;
    }
  } else if (data.tabType === "Contribution" || type === "Contributions") {
    if (data.status === "Reversed") {
      isParenthesis = true;
    } else {
      isParenthesis = false;
    }
  } else if (data.reversal || data.exchangeType === "from") {
    isParenthesis = true;
  }

  return isParenthesis;
};

export const isIfTiff = data => {
  let isTiff = false;

  if (data.length > 0) {
    data.forEach((trax) => {
      if (trax.poolNumber === "75") {
        isTiff = true;
      }
    });
  }

  return isTiff;
};

export const isIfLcp = data => {
  let isLCP = false;

  if (data.length > 0) {
    isLCP = data.some((trax) => trax.poolNumber === "76")
  }

  return isLCP;
};

export const renderDate = (date, searchText) => {
  if (date) {
    return (
      <div class="tdata-summary">
        <Highlighter
          highlightStyle={{
            color: "black",

            fontWeight: 600,

            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={milliToDate(date)}
        >
          {milliToDate(date)}
        </Highlighter>
      </div>
    );
  } else {
    return <div class="tdata-summary">-</div>;
  }
};

export const balanceSummary = (data) => {
  const { from, to, exchange, other, grant, contribution, marketMovement } = data;
  return {
    beginning: from.amount,
    ending: to.amount,
    exchange,
    other,
    grant,
    contribution,
    marketMovement
  }
};
